import { render, staticRenderFns } from "./selectModel.vue?vue&type=template&id=5242c20e&scoped=true"
import script from "./selectModel.vue?vue&type=script&lang=js"
export * from "./selectModel.vue?vue&type=script&lang=js"
import style0 from "./selectModel.vue?vue&type=style&index=0&id=5242c20e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5242c20e",
  null
  
)

export default component.exports